// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2mjxI","signatureButtonsRight":"ModalSign_signatureButtonsRight__3gwb-"};